import { LOCALE } from './constants';
import { TranslationsMap } from './typings';
import en from './messages/en.json';

const defaultLanguage = LOCALE.en;

const translations: TranslationsMap = {
  en,
};

export { translations, defaultLanguage };
